import { render, staticRenderFns } from "./ead-curso-conteudo.vue?vue&type=template&id=08b940d0&scoped=true&"
import script from "./ead-curso-conteudo.vue?vue&type=script&lang=js&"
export * from "./ead-curso-conteudo.vue?vue&type=script&lang=js&"
import style0 from "./ead-curso-conteudo.vue?vue&type=style&index=0&id=08b940d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b940d0",
  null
  
)

export default component.exports